import styled from 'styled-components'

const Container = styled.div<{
  noPadding?: boolean
  paddingY?: number
  width?: number
  overflowHidden?: boolean
}>`
  box-sizing: border-box;
  width: 100%;
  max-width: ${({ width }) => (width ? `${width}px` : '1300px')};

  margin: 0 auto;
  padding: ${({ paddingY }) => (paddingY ? `${paddingY}px` : 0)} 16px;

  ${({ overflowHidden }) =>
    overflowHidden &&
    `
  overflow: hidden;
`}

  ${({ noPadding }) =>
    noPadding &&
    `
    padding: 0;
  `}
`

Container.defaultProps = {
  overflowHidden: true,
}

export default Container
